import gallery1 from "../images/Gallery/gallery1.jpeg";
import gallery2 from "../images/Gallery/gallery2.jpeg";
import gallery3 from "../images/Gallery/gallery3.jpeg";
import gallery4 from "../images/Gallery/gallery4.jpeg";
import gallery5 from "../images/Gallery/gallery5.jpeg";
import gallery6 from "../images/Gallery/gallery6.jpeg";
import gallery7 from "../images/Gallery/gallery7.jpeg";
import gallery8 from "../images/Gallery/gallery8.jpeg";

import gallery10 from "../images/Gallery/gallery10.jpeg";
import gallery11 from "../images/Gallery/gallery11.jpeg";
import gallery12 from "../images/Gallery/gallery12.jpeg";
/* GALLERY DATA */
export const galleryData = [
  {
    img: gallery1,
    title: "",
    desc: "",
  },
  {
    img: gallery2,
    title: "",
    desc: "",
  },
  {
    img: gallery3,
    title: "",
    desc: "",
  },
  {
    img: gallery4,
    title: "",
    desc: "",
  },
  {
    img: gallery5,
    title: "",
    desc: "",
  },
  {
    img: gallery6,
    title: "",
    desc: "",
  },
  {
    img: gallery7,
    title: "",
    desc: "",
  },
  {
    img: gallery8,
    title: "",
    desc: "",
  },
 
  {
    img: gallery10,
    title: "",
    desc: "",
  },
  {
    img: gallery11,
    title: "",
    desc: "",
  },
  {
    img: gallery12,
    title: "",
    desc: "",
  },
];

/* REVIEW DATA */
export const reviewsData = [
  {
    name: "Sudipta Naiya",
    message:
      " Exceptional hospitality that enhances the overall travel experience. Highly recommended for anyone looking to enjoy a memorable tour.",
    rating: 4,
  },
  {
    name: " Amit Kumar",
    message:
      "An approachable and kind individual who goes above and beyond to assist travelers. Their support and guidance greatly enhance the overall tour experience.",
    rating: 4.5,
  },
  {
    name: "Satyajit Ganguly",
    message:
      " If you are planning to visit Sikkim, this travel agency offers reliable service and a well-organized travel experience.",
    rating: 5,
  },
];